import React, { useEffect, useState } from 'react'
import TitleBar from '../../Common/TitleBar';
import SidePanelAdmin from '../../Common/SidePanelAdmin';
import DashboardHeader from '../../Common/DashboardHeader';
import { ScrollPanel } from 'primereact/scrollpanel';
import DashboardFooter from '../../Common/DashboardFooter';
import { IoCalendarClearOutline, IoSearchOutline } from 'react-icons/io5';
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBinLine } from 'react-icons/ri';
import PlanRow from './PlanRow';
import { useDispatch } from 'react-redux';
import { fetchAdminplanAction } from '../../../Redux/Actions/AdminUserActivity';
import PlanModel from './PlanModel';
import Pagination from '../../Common/Pagination';
import { FaSpinner } from 'react-icons/fa6';

const Plans = () => {
    const [isActive, setIsActive] = useState(true);
    const dispatch = useDispatch()
    const toggleClass = () => {
        setIsActive(!isActive);
    }
    const [loader, setLoader] = useState({
        fetch: true,
        update: false,
        delete: false

    })
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalItemOnPage: 20
    });
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const [sortOrder, setSortOrder] = useState('asc');
    const [q, setQ] = useState('')

    const [data, setData] = useState([])
    const fetchData = () => {
        dispatch(fetchAdminplanAction("fetch-package", setData, setLoader, loader))
    }
    useEffect(() => {
        fetchData()
    }, [])
    const handlesort = () => {

        const sortedData = [...data].sort((a, b) => {

            return sortOrder === 'asc' ? a.id - b.id : b.id - a.id;
        });

        setData(sortedData);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    }

    const indexOfLastTodo = pagination.currentPage * pagination.totalItemOnPage;
    const indexOfFirstTodo = indexOfLastTodo - pagination.totalItemOnPage;
    const currentTodo = data.slice(indexOfFirstTodo, indexOfLastTodo)
    return (

        <>
            <TitleBar title="User Plan" />
            <div className="dashboard earnings_payouts container-fluid overflow-hidden">
                <div className="row">

                    <div className={`col-lg-2 col-md-3 col-sm-4 col-12 side-nav ${isActive ? "nav-show" : "nav-hide"}`}>
                        <SidePanelAdmin />
                    </div>
                    <div className={` p-0 ${isActive ? "col-lg-10 col-md-9 col-sm-8 col-12" : "col-12"} main-content`}>
                        <div>
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 ps-0 pe-0">
                                    <div className="dashboard-in main_task_wrapper">
                                        <DashboardHeader toggleSidebar={toggleClass} title="User Plan" />
                                        <ScrollPanel className="custombar2 content-area pt-0" style={{ height: "100vh" }}>
                                            <div className="content-area-in tab-style">
                                                <div className='creator_new_task h-100'>
                                                    <div className="table-bar mobile-table-bar h-10 mt-3 mt-md-2">
                                                        <div className="table-bar-left">
                                                            <div className="table-bar-icon">
                                                                <div className="table-nav">
                                                                </div>
                                                                <ul>
                                                                    <li title="Sort by Id" onClick={handlesort}>
                                                                        <img src={require("../../../images/icon/sort.svg").default} alt="" />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className="table-bar-right d-flex align-items-center gap-3">
                                                            <button className='theme-btn py-1' onClick={() => setShow(true)}>Add Plans</button>
                                                            <div className="header-search">
                                                                <input type="text"
                                                                    placeholder="Search"
                                                                    name="q"
                                                                    value={q}
                                                                    onChange={(e) => setQ(e.target.value)}
                                                                />
                                                                <span className="left-icon"><IoSearchOutline /></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="table-responsive position-relative mt-4 mob-table">
                                                        <table className="table theme-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>S.No</th>
                                                                    <th>Package name</th>
                                                                    <th>Price</th>
                                                                    <th>Credited</th>
                                                                    <th>Description</th>
                                                                    <th>Created at</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            {
                                                                loader.fetch ? <div className='d-flex align-items-center justify-content-center' style={{ width: "100%", position: "absolute" }}><FaSpinner className='spin mt-3' style={{ fontSize: "20px" }} /></div> :
                                                                    <tbody>
                                                                        {
                                                                            currentTodo.length > 0 ? currentTodo.map((curElem, i) => {
                                                                                return (
                                                                                    <React.Fragment key={i}>
                                                                                        <PlanRow curElem={curElem} loader={loader} setLoader={setLoader} fetchData={fetchData} />
                                                                                    </React.Fragment>
                                                                                )
                                                                            }) : <td className='text-center pt-2' colSpan={7}>No plan </td>}
                                                                    </tbody>}
                                                        </table>
                                                    </div>
                                                    <div className='my-4'>
                                                        <Pagination
                                                            listData={data}
                                                            pagination={pagination}
                                                            setPagination={setPagination}
                                                            currentTodo={currentTodo}
                                                            listArr={data}
                                                            loader={loader.fetch}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </ScrollPanel>
                                    </div>
                                </div>
                                <div className="d-block d-lg-none">
                                    <DashboardFooter
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PlanModel show={show} handleClose={handleClose} loader={loader} setLoader={setLoader} fetchData={fetchData} curElem={false} />
        </>
    )
}

export default Plans
